import React from "react";
import type { SolanaLogEntry } from "../types";

interface SolanaLogPanelProps {
  logs: SolanaLogEntry[];
  explorerTxUrl: (signature: string) => string;
}

const COLORS: Record<SolanaLogEntry["type"], string> = {
  info: "#b0c4de",
  success: "#86efac",
  error: "#ef4444",
  warning: "#fbbf24",
};

export function SolanaLogPanel({ logs, explorerTxUrl }: SolanaLogPanelProps) {
  return (
    <details className="wallet-recovery-log" open>
      <summary>Recent recovery activity</summary>
      <div
        style={{
          maxHeight: "260px",
          overflowY: "auto",
          fontSize: "12px",
        }}
      >
        {logs.length === 0 ? (
          <div style={{ color: "#8092b0" }}>No activity yet</div>
        ) : (
          logs
            .slice()
            .reverse()
            .map((entry) => (
              <div
                key={entry.id}
                style={{ padding: "4px 0", color: COLORS[entry.type] }}
              >
                <span style={{ color: "#6b7a99" }}>
                  {entry.timestamp.toLocaleTimeString()}{" "}
                </span>
                {entry.message}
                {entry.signature ? (
                  <>
                    {" "}
                    <a
                      href={explorerTxUrl(entry.signature)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#60a5fa" }}
                    >
                      view ↗
                    </a>
                  </>
                ) : null}
              </div>
            ))
        )}
      </div>
    </details>
  );
}
